/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Icon, message, Table, Drawer, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {
	
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedBarangayTerm: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Utilities</a></li>
									<li className="breadcrumb-item active">Audit Trail</li>
								</ol>
							</div>
							<h4 className="page-title">Audit Trail</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row>
									<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
										this.setState({ searchText: e.target.value })
									}}/>
								</Row>
								<br />
								<Row>
									<Query query={AUDIT_TRAIL} variables={{ searchFilter: filters, barangay_uid }}>
										{({ loading, error, data }) => {
											if (error) return <Empty/>

											let barangayAuditTrail = _.has(data,'barangayAuditTrail') ? data.barangayAuditTrail.data : []
											barangayAuditTrail = barangayAuditTrail.map((auditTrail, key) => Object.assign({}, auditTrail, { key }))
											let _pagination = _.has(data, 'barangayAuditTrail') ? data.barangayAuditTrail.pagination : {}
											_pagination = Object.assign({}, _pagination, {
												pageSizeOptions: ['10', '25', '50'],
												showSizeChanger: true,
												total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
												showTotal: (total) => `Total ${total} items`
											})

											const columns = [
												// {
												// 	title: 'UID',
												// 	dataIndex: 'uid',
												// 	key: 'uid',
												// 	width: 300
												// }, 
												{
													title: 'User',
													key: 'full_name',
													dataIndex: 'full_name'
												}, {
													title: 'Module',
													key: 'module_name',
													dataIndex: 'module_name'
												}, {
													title: 'Action',
													key: 'actions',
													dataIndex: 'actions'
												}, {
													title: 'Description',
													key: 'log_message',
													dataIndex: 'log_message'
												}, {
													title: 'Date/Time',
													key: 'created_at',
													render: (record) => {
														return (
															<span>{moment(record.created_at).format('lll')}</span>
														)
													}
												}]
											return (
												<Table 
													loading={loading}
													columns={columns} 
													dataSource={barangayAuditTrail} 
													bordered
													onChange={this.handleOnChange}
													pagination={_pagination}
													scroll={{ x: 1020 }}
												/>
											)
										}}
									</Query>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const AUDIT_TRAIL = gql`
    query barangayAuditTrail($barangay_uid: String, $searchFilter: SearchParams) {
		barangayAuditTrail(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
